<div class="log-reg-side-bg">
    <div class="row">
        <!-- <div class="col-lg-7">
            <div class="cntntRightArea">
                <h3>It's time to put your</h3>
                <h2>Peace of mind first</h2>
                <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the
                    visual form of a document or a typeface without relying on</p>
            </div>
        </div> -->

        <div class="col-lg-5 box-align">
            <div class="login-box">
                <div class="">
                    <div class="card-header text-center mb-3 border-0">
                        <a [routerLink]="['/']" class="h1"><img src="../../../assets/img/aero_lounge-logo.png"></a>
                    </div>
                    <div *ngIf="!showResetForm" class="card-body">
                        <!-- <p class="login-box-msg">Sign in to start your session</p> -->

                        <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()">
                            <div class="mb-3">
                                <input formControlName="email" type="email" class="form-control" placeholder="Email" />
                                <div *ngIf="forgotPasswordForm.controls['email'].invalid && (forgotPasswordForm.controls['email'].dirty || forgotPasswordForm.controls['email'].touched)"
                                    class="alert alert-danger mt-2">
                                    <div
                                        *ngIf="forgotPasswordForm.controls['email'].errors?.['required'] || forgotPasswordForm.controls['email'].errors?.['email']">
                                        Please enter valid email id
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <button type="submit" class="btn btn-primary d-block w-100 green-bg"
                                        [disabled]="forgotPasswordForm.invalid">Send OTP</button>
                                </div>
                                <div class="col-12 mb-3">
                                    <button class="btn btn-primary d-block w-100"
                                        [routerLink]="['/login']">Login</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- Show reset form only after OTP is sent -->
                    <div *ngIf="showResetForm" class="card-body">
                        <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
                            <div class="mb-3">
                                <input formControlName="email" type="email" class="form-control" placeholder="Email"
                                    readonly />
                            </div>
                            <div class="mb-3">
                                <input formControlName="code" type="text" class="form-control"
                                    placeholder="Enter OTP Code" />
                            </div>
                            <!-- New Password -->
                            <div class="mb-3">
                                <input formControlName="new_password" type="password" class="form-control"
                                    placeholder="New Password" />
                                <div *ngIf="resetPasswordForm.get('new_password')?.touched"
                                    class="text-danger mt-1 small">
                                    <div *ngIf="resetPasswordForm.get('new_password')?.hasError('required')">
                                        Password is required.
                                    </div>
                                    <div *ngIf="resetPasswordForm.get('new_password')?.hasError('minlength')">
                                        Password must be at least 8 characters long.
                                    </div>
                                    <div *ngIf="resetPasswordForm.get('new_password')?.hasError('pattern')">
                                        Password must contain:
                                        <ul class="mb-0">
                                            <li>At least one uppercase letter</li>
                                            <li>At least one lowercase letter</li>
                                            <li>At least one number</li>
                                            <li>At least one special character</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <!-- Confirm Password -->
                            <div class="mb-3">
                                <input formControlName="confirm_password" type="password" class="form-control"
                                    placeholder="Confirm Password" />
                                <div *ngIf="resetPasswordForm.get('confirm_password')?.touched && resetPasswordForm.hasError('passwordMismatch')"
                                    class="text-danger mt-1 small">
                                    Passwords do not match.
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <button type="submit" class="btn btn-primary d-block w-100 green-bg"
                                        [disabled]="resetPasswordForm.invalid">Reset Password</button>
                                </div>
                            </div>
                        </form>
                    </div>


                    <!-- /.login-card-body -->
                </div>
            </div>
        </div>
    </div>
</div>